import { createContext } from 'react';

const dcProfessionalContext = createContext();
export default dcProfessionalContext;
